import { render, staticRenderFns } from "./import-success.vue?vue&type=template&id=4b0bb40a&scoped=true"
import script from "./import-success.vue?vue&type=script&lang=js"
export * from "./import-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0bb40a",
  null
  
)

export default component.exports